import React from 'react';
import { RouteComponentProps, Link, NavLink } from 'react-router-dom';
import { AppServices } from 'services/AppServices';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Locale from 'localization/Localization';
import { Layout } from 'components/common/Layout';
import { UserProvider, UserConsumer } from 'components/contexts/UserContext';
import MomentumAppBanner from 'components/banner/MomentumAppBanner';

interface HomePageState {
	verificationSent?: boolean;
	errorOccured?: boolean;
}

export class HomePage extends React.Component<RouteComponentProps<{}>, HomePageState>
{
	constructor(props: RouteComponentProps<{}>) {
		super(props);

		this.state = {};
		this.onResendVerification = this.onResendVerification.bind(this);
	}

	public async componentDidMount() {
		document.title = Locale.getPageTitle('page_home');
	}

	public render() {
		const pageContent = <>
			<h1>{Locale.get('page_home')}</h1>
			<p id='welcome-text'>{Locale.get('home_welcome')}</p>
			<UserConsumer>
				{
					context => <>
						{/* {
							context.email === undefined &&
							<Alert variant='primary'>
								{Locale.get('home_alertEmailNotDefined')}
								<br /><NavLink to='/account#email-section'>{Locale.get('home_linkAddEmail')}</NavLink>
							</Alert>
						} */}
						{
							context.email !== undefined &&
							context.emailVerified !== true &&
							this.state.verificationSent === undefined &&
							<Alert variant='warning'>
								{Locale.get('home_alertEmailNotVerified')}
								<br /><Link to='' onClick={this.onResendVerification}>{Locale.get('home_linkResendVerification')}</Link>
							</Alert>
						}
						{
							context.email !== undefined &&
							context.hasPassword !== true &&
							<Alert variant='warning'>
								{Locale.get('home_alertPasswordNotSet')}
								<br /><NavLink to='/account#password-section'>{Locale.get('home_linkSetPassword')}</NavLink>
							</Alert>
						}
						{
							this.state.verificationSent &&
							<Alert variant='success'>{Locale.get('home_alertVerificationSent')}</Alert>
						}
						{
							this.state.errorOccured &&
							<Alert variant='danger'>{Locale.get('home_alertError')}</Alert>
						}
					</>
				}
			</UserConsumer>
			<div className='home-page-cards'>
				<Card>
					<Card.Body>
						<Card.Title>{Locale.get('card_programsTitle')}</Card.Title>
						<Card.Text>
							{Locale.get('card_programsText')}
						</Card.Text>
						<NavLink to='/programs'>{Locale.get('card_programsLink')}</NavLink>
					</Card.Body>
				</Card>
				<Card>
					<Card.Body>
						<Card.Title>{Locale.get('card_accountTitle')}</Card.Title>
						<Card.Text>
							{Locale.get('card_accountText')}
						</Card.Text>
						<NavLink to='/account'>{Locale.get('card_accountLink')}</NavLink>
					</Card.Body>
				</Card>
				<UserConsumer>
					{
						context => <>
							{
								context.org !== undefined && <Card>
									<Card.Body>
										<Card.Title>{Locale.get('card_contentTitle')}<Badge variant='primary'>Pro</Badge></Card.Title>
										<Card.Text>
											{Locale.get('card_contentText')}
										</Card.Text>
										<NavLink to='/content'>{Locale.get('card_contentLink')}</NavLink>
									</Card.Body>
								</Card>
							}
						</>

					}
				</UserConsumer>
			</div>
			<MomentumAppBanner />
		</>

		return <Layout>{pageContent}</Layout>;
	}

	private onResendVerification(e: React.MouseEvent<HTMLAnchorElement>) {
		e.preventDefault();

		this.setState({ errorOccured: false, verificationSent: false })
		const email = UserProvider.getData().email;

		if (email === undefined)
			return;

		AppServices.loginService.resendVerification(email)
			.then(() => {
				this.setState({ verificationSent: true })
			})
			.catch(reason => {
				console.error(reason);
				this.setState({ verificationSent: false, errorOccured: true })
			})
	}
}